import { Component, Input, } from '@angular/core';
import { instrumentCategoryColors } from 'src/app/shared/constants';
import { InstrumentDropdownInput } from './instrument-dropdown-input';
import { InstrumentCategories } from '../../charts';

@Component({
  selector: 'libero-instrument-chart-dropdown',
  templateUrl: './instrument-chart-dropdown.component.html',
  styleUrls: ['./instrument-chart-dropdown.component.scss'],
  standalone: false
})
export class InstrumentChartDropdownComponent {
  @Input() public dropdownInput?: InstrumentDropdownInput;
  @Input() public translateNames? = true;
  @Input() public customColor?: string;
  @Input() public region = false;

  public instrumentCategoryColors = instrumentCategoryColors;

  public get isCash(): boolean {
    return !this.region &&
      !!this.dropdownInput?.instrumentContent[0]?.instrument.cash;
  }

  public get rowColor(): string {
    if(this.isCash) {
      return instrumentCategoryColors['CASH'];
    }
    return this.customColor ?? instrumentCategoryColors[this.dropdownInput!.categoryName as InstrumentCategories];
  }

  public instrumentSum(): number {
    if (!this.dropdownInput) {
      return NaN;
    }

    const sum = this.dropdownInput.instrumentContent.map(item => item.weight);
    return sum.reduce((partialSum, a) => partialSum + a, 0) * 100; // sum all * 100%
  }
}
